/**
 * Created by: cparaschiv
 * Date: 03.04.2013, 12:27
 */

(function($) {

    var ui = kendo.ui,
        Widget = ui.Widget,
        Grid = ui.Grid;

    var TsGrid = Grid.extend({

        init: function(element, options) {
            var me = this,
                o = options,
                $element = $(element);

            // the config rendered by the server-side widget is invalid
            if (o.toolbar && $.isArray(o.toolbar.command)) {
                o.toolbar = o.toolbar.command;
            }

            Grid.fn.init.call(this, element, options);
        },

        _dataSource: function(){
            var me = this,
                options = me.options,
                dsConfig = options.dataSource;

            //convert dataSource property from config to actual TS.GridDataSource instance
            if (dsConfig && dsConfig.type === 'grid') {
                dsConfig.data = dsConfig.data || options.data;
                options.dataSource = new TS.GridDataSource(dsConfig);
            }

            Grid.fn._dataSource.call(this);
        },

       /* _renderContent: function(data, colspan, groups) {
            var me = this,
                emptyContent;

            Grid.fn._renderContent.call(this, data, colspan, groups);

            emptyContent = $('.grid-empty-content', me.content);
            if (me.tbody.html() == '') {
                if (!emptyContent.length)
                    me.content.append(TS.UI.Renderers.list._default.getEmptyContent());
            } else {
                if (emptyContent.length)
                    emptyContent.remove();
            }
        },*/

        deselect: function(el) {
            var that = this,
                selectable = that.selectable;
            return selectable.deselect(el);
        },

        options: {
             name: "TsGrid"
        }

    });

    ui.plugin(TsGrid);

})(jQuery);
